<template>
    <div>
        <div class="modal fade" tabindex="-1" id="plansOptions">
            <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title modal-top-text">Choose Payment method</h5>
                        <button @click="activePayment = ''" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="amount-section">
                            <h6>{{ activePayment === 'transfer' ? 'Transfer' : 'Deduct' }}</h6>
                            <h3>₦{{ Number(paymentData.amount).toLocaleString() }}</h3>
                            <p>{{ activePayment === 'transfer' ? 'To' : 'From' }}</p>
                        </div>
                        <div v-if="activePayment != 'transfer'">
                            <div class="payment-option-list" :class="[activePayment === 'smart_wallet' ? 'activeBtn' : '']">
                                <button class="btn" @click="activePayment = 'smart_wallet'">
                                    <div>
                                        <img src="../assets/icons/smart-logo.svg" alt="wallet">
                                        <span>Smart Wallet</span>
                                    </div>
                                    <div class="rouded-cycle"></div>
                                </button>
                            </div>

                            <div class="payment-option-list" :class="[activePayment === 'voucher' ? 'activeBtn' : '']">
                                <button class="btn" @click="activePayment = 'voucher'">
                                    <div>
                                        <img style="width: 27%;" src="../assets/subscription/blue-safe.svg" alt="voucher">
                                        <span>Voucher</span>
                                    </div>
                                    <div class="rouded-cycle"></div>
                                </button>
                            </div>

                            <div class="payment-option-list" :class="[activePayment === 'transfer' ? 'activeBtn' : '']">
                                <button class="btn"  @click="activePayment = 'transfer'">
                                    <div>
                                        <img src="../assets/subscription/bank-transfer.svg" alt="transfer">
                                        <span> Bank Transfer</span>
                                    </div>
                                    <div class="rouded-cycle"></div>
                                </button>
                            </div>
                            <div class="payment-option-list" :class="[activePayment === 'paystack' ? 'activeBtn' : '']">
                                <!-- <button class="btn"  @click="activePayment = 'paystack'; $refs.paystack.click()">
                                    <div>
                                            <img src="../assets/subscription/paystack-blue.svg" alt="paystack">
                                            <span>Paystack</span>
                                    </div>
                                    <div class="rouded-cycle"></div>
                                </button> -->
                                <paystack
                                    :channels="channels"
                                    :amount="paymentData.amount * 100"
                                    :email="email"
                                    :paystackkey="PUBLIC_KEY"
                                    :reference="reference"
                                    :callback="processPayment"
                                    :close="close"
                                    class="btn"
                                    type="button"
                                    @click="$refs.paystack.click()"
                                >
                                <div>
                                            <img src="../assets/subscription/paystack-blue.svg" alt="paystack">
                                            <span>Paystack</span>
                                    </div>
                                    <div class="rouded-cycle"></div>
                                </paystack>
                            </div>
                        </div>

                        <div  v-if="activePayment === 'transfer'">
                            <div class="transfer-holder">
                                <div class="row">
                                    <div class="col-6 col-md-6">
                                        <div class="bank-details">
                                            <h6>Bank Name</h6>
                                            <h5>Stanbic IBTC</h5>
                                        </div>
                                        <div class="bank-details">
                                            <h6>Account Name</h6>
                                            <h5>Shelta Panacea Limited</h5>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-6">
                                        <div class="bank-details">
                                            <h6>Account Number</h6>
                                            <h5>0050024451</h5>
                                        </div>
                                        <!-- <div class="bank-details">
                                            <h6>Expires in</h6>
                                            <h5>24:00</h5>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="directionBtns">
                                <button class="btn confirm" @click="closePlansModal()" data-dismiss="modal" aria-label="Close">Confirm payment</button>
                                <button class="btn change" @click="activePayment = ''">Change payment method</button>
                            </div> -->
                        </div>
                        

                        <div class="agree-btn">
                            <button v-if="activePayment != ''" class="btn change" @click="activePayment = ''">Change payment method</button>
                            <button class="btn" :disabled="paymentLoader || activePayment == ''" @click="submitPayment()">
                               Continue
                               <i
                                class="fa fa-spinner fa-spin ml-3 f-12 btn-loader"
                                v-if="paymentLoader"
                            ></i>
                            </button>
                        </div>
                    </div>
               
                </div>
            </div>
        </div>

         <!-- Modal to enter voucher starts Not in use -->
        <!-- <div
        tabindex="-1"
        class="modal fade"
        id="voucherModal"
        role="dialog"
        aria-labelledby="sub"
        aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" style="margin-bottom: 30px">
                <div class="modal-header">
                    <h5 class="modal-title confirmation-header">
                    Pay with voucher
                    </h5>
                    <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    >
                    <span
                        @click="paymentType = ''"
                        aria-hidden="true"
                        style="font-weight: normal"
                        >X</span
                    >
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                    <input @input="formatInputRemoveCharacters" maxlength="19" :value="formattedInput" class="form-control input-text" type="text" name="vocher" id="voucher" placeholder="Enter voucher numbers">
                    </div>
                </div>
                <div class="modal-footer modal-button">
                    <button
                    @click="voucherNumber = ''"
                    type="button"
                    class="btn cancel voucherCancel"
                    data-dismiss="modal"
                    >
                    Cancel
                    </button>
                    <button
                    :disabled="voucherLoading"
                    ref=""
                    type="button"
                    class="btn continue voucherPay"
                    @click="payWithVoucher()"
                    >
                    Pay
                    <i
                        class="fa fa-spinner fa-spin ml-3 f-12 btn-loader"
                        v-if="voucherLoading"
                    ></i>
                    </button>
                </div>
                </div>
            </div>
        </div> -->
        <!-- Modal to enter voucher ends -->

        <VoucherPin :voucherPayment="vocherOptionData"></VoucherPin>



    </div>
</template>

<script>
// import authentication from '../services/authentication';
import { EventBus } from './EventBus';
import paystack from "vue-paystack";
import { staticdata } from "../data";
import $ from "jquery";
import plansbillings from '../services/plansBillings';
import VoucherPin from './VoucherPin'
export default {
    name: "PlansPaymentOptions",
    // props: ['paymentData'],
    components: {
        paystack,
        VoucherPin
    },
    data() {
        return {
            loading: false,
            paymentLoader: false,
            voucherLoading: false,
            voucherNumber: "",
            activePayment: "",
            paymentData: "",
            full_name: "",
            email: "",
            PUBLIC_KEY: staticdata.paystackkeylive,
            // PUBLIC_KEY: staticdata.paystackkeytest,
            user: "",
            reference: "",
            channels: ["card", "bank", "ussd", "qr", "bank_transfer"],
            // user: "",
            vocherOptionData: {
                url: "",
                smart_plan_id: '',
                payment_method: '',
                amount:  '',
            }
        }
    },
    created() {
        const user = this.$store.getters.getUser;
        this.email = user.email;
        this.$root.$refs.plansOptions = this;
        EventBus.$on('dataForPayment', (data) => {
            this.paymentData = data;
        });
    },
    computed: {
        formattedInput() {
        return this.formatWithHyphens(this.voucherNumber);
        },
    },
    methods: {
        formatInputRemoveCharacters(event) {
            let value = event.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric values
            value = value.slice(0, 16); // Limit to 16 digits (without hyphens)
            this.voucherNumber = value; // Update the raw input
        },
        formatWithHyphens(value) {
            return value.replace(/(\d{4})(?=\d)/g, "$1-"); // Add hyphen after every 4 digits except last
        },
        plansOptionsModal() {
            $("#plansOptions")
            .addClass("fade")
            .modal("show");
        },
        openVoucherPinModal() {
            $("#plansOptions")
            .removeClass("fade")
            .modal("hide");
            $("#plansOptions")
            .removeClass("fade")
            .modal("hide");
            this.vocherOptionData.url = "smartsubscriptionwithvoucher";
            this.vocherOptionData.smart_plan_id = this.paymentData.id;
            this.vocherOptionData.amount = this.paymentData.amount;
            this.vocherOptionData.payment_method = "voucher";
            return this.$root.$refs.voucherpin.openVoucherPinModal();
            // $("#voucherModal")
            // .addClass("fade")
            // .modal("show");
        },
        closePlansModal() {
            return this.$root.$refs.plans.closePlansModal();
        },
        processPayment(response) {
            this.paymentLoader = true;
            const ref = response.reference;
            if (response.status === "success") {
                let body = {
                        smart_plan_id: this.paymentData.id,
                        payment_method: 'paystack',
                        amount:  this.paymentData.amount,
                        referencecode: ref,
                    }
                body = JSON.stringify(body);
                plansbillings.billPayment(body)
                .then((res) => {
                    this.paymentLoader = false;
                    // console.log("Subscription response", res);
                    if (res.success === "success") {
                    location.reload();
                    $("#plansOptions")
                        .removeClass("fade")
                        .modal("hide");
                        this.$toast.success("Payment successful");
                    }
                    if (res.error) {
                        this.paymentLoader = false;
                        this.$toast.error(res.error);
                        $("#plansOptions")
                        .removeClass("fade")
                        .modal("hide");
                    }
                })
                .catch((err) => {
                    console.log("err", err);
                    this.$toast.error(err);
                    // return this.$store.commit("setApiFailed", "Error occured");
                });
            }
        },
        submitPayment() {
            if (this.activePayment == "voucher") {
                this.openVoucherPinModal();
                return;
            }
            this.paymentLoader = true;
            let body = {
                smart_plan_id: this.paymentData.id,
                payment_method: this.activePayment,
                amount:  this.paymentData.amount,
            }
            body = JSON.stringify(body);
            plansbillings.billPayment(body)
            .then((res) => {
                // console.log("Payment response", res);
                this.paymentLoader = false;
                if (res.success === "success") {
                location.reload();
                $("#plansOptions")
                    .removeClass("fade")
                    .modal("hide");
                    this.$toast.success("Payment successful");
                }
                if (res.error) {
                    this.$toast.error(res.error);
                    this.paymentLoader = false;
                    $("#plansOptions")
                    .removeClass("fade")
                    .modal("hide");
                }
            })
            .catch((err) => {
                this.paymentLoader = false;
                console.log("err", err);
                this.$toast.error(err);
                // return this.$store.commit("setApiFailed", "Error occured");
            });

        },
        // payWithVoucher() {
        //     this.voucherLoading = true;
        //     if (this.voucherNumber === "") {
        //         this.voucherLoading = false;
        //         return this.$toast.error("Enter voucher numbers");
        //     }
        //     let body = {
        //         smart_plan_id: this.paymentData.id,
        //         payment_method: this.activePayment,
        //         amount:  this.paymentData.amount,
        //         voucher: this.voucherNumber
        //     }
        //     plansbillings.billPayment(JSON.stringify(body)).then(res => {
        //         // console.log("res", res);
        //         this.voucherLoading = false;
        //         if (res.success) {
        //         $("#voucherModal")
        //             .removeClass("fade")
        //             .modal("hide");
               
        //         this.$toast.success("Subscription successful");
        //         // return this.$store.commit("setApiSuccess", "Subscription successful");
        //         }
        //         if (res.error) {
        //         return this.$toast.error(res.error);
        //         }
        //     }).catch((err) => {
        //         console.log(err);
        //         this.voucherLoading = false;
        //     });
        // },
        // Paystack close function or cancel payment
        close: () => {
        // console.log("You closed checkout page");
        },
    },
}
</script>


<style scoped lang="scss">
$primary: #0033ea;
$white: #ffffff;
$yellow: #ffb100;
$asheGrey: #555C74;
$offblack: #2B3352;

$shelta-black: #000a2f;
$shelta-gray: #555c74;

$secondary: #ffffff;
$black: #000000;
$dline: #dddddd;


.modal-top-text {
    font-family: Lato;
    font-size: 18px;
    font-weight: 400;
    line-height: 36px;
    text-align: left;

}

.amount-section {
    margin-bottom: 25px;
    h6 {
        font-family: Lato;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        text-align: center;
        color: $offblack;
    }
    h3 {
        font-family: Lato;
        font-size: 24px;
        font-weight: 700;
        line-height: 30px;
        text-align: center;
        color: $offblack
    }
    p {
        font-family: Lato;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        text-align: center;
        color: $offblack
    }
}

.payment-option-list {
    display: flex;
    align-items: center;
    height: 64px;
    border: 1px solid #E4E7EC;
    border-radius: 8px;
    margin-bottom: 10px;
    padding: 0 15px;
    button {
        font-family: Lato;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        text-align: left;
        color: $asheGrey;
        outline: 0;
        box-shadow: none;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        img {
            margin-right: 15px;
        }
    }
}

.agree-btn {
    margin-top: 40px;
    margin-bottom: 20px;
    button {
        color: $white;
        background: $primary;
        outline: 0;
        box-shadow: none;
        font-family: Lato;
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
        text-align: center;
        border-radius: 8px;
        height: 48px;
        width: 100%;
    }
}
.change {
    background: none !important;
    border: 1px solid $primary !important;
    color: $primary !important;
    margin-bottom: 10px;
}

.rouded-cycle {
    width: 16px;
    height: 16px;
    border-radius: 50px;
    border: 1px solid #D0D5DD;
}

.activeBtn {
    border: 1px solid $primary;
}

.transfer-holder {
    background: #F5F5F7;
    border-radius: 8px;
    padding: 20px 15px;
}
.bank-details {
    h6, h5 {
        font-family: Lato;
        font-size: 14px;
        line-height: 24px;
        text-align: left;
    }
    h6 {
        font-weight: 400;
        color: $asheGrey;
        font-weight: bold;
        font-size: 16px !important;
    }
    h5 {
        font-weight: 500;
        color: $offblack;
        white-space: nowrap;
    }
}

.directionBtns {
    margin-top: 40px;
    button {
        font-family: Lato;
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
        text-align: center;
        box-shadow: none;
        outline: 0;
        width: 100%;
        height: 48px;
    }
    .confirm {
        background: $primary;
        color: $white;
        margin-bottom: 10px;
    }
    .change {
        border: 1px solid $primary;
        color: $primary;
        margin-bottom: 30px;
    }
}


// Voucher payment starts
.confirmation-header {
  color: $shelta-black;
  text-align: center;
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%;
}

.confirmation-body {
  p {
    text-align: left;
    color: $shelta-black;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin-bottom: 10px;
  }

  span {
    font-weight: bold;
  }
}
.voucherCancel, .voucherPay {
  width: 45% !important;
}


.input-text {
  font-family: Lato;
  font-weight: 400;
  font-size: 16px;
  box-shadow: none;
  outline: 0;
  color: #555C74;
  height: 60px;

}

.main-footer-button {
  justify-content: space-around !important;
}
.modal-button {
  // padding-top: 24px;
  // padding-bottom: 40px;
  padding-top: 15px;
  padding-bottom: 20px;
  display: flex;
  justify-content: space-between;
  border-top: none !important;

  .cancel {
    border-radius: 6px;
    border: 1px solid $dline;
    color: $shelta-black;
    width: 178px;
    height: 48px;
    text-align: center;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    outline: 0;
    box-shadow: none;
  }

  .continue {
    border-radius: 6px;
    background: $primary;
    color: $secondary;
    // width: 178px;
    min-height: 48px;
    text-align: center;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    outline: 0;
    box-shadow: none;
  }
}
// Voucher payment ends

</style>